/* eslint-disable */
import React, { useEffect, useState } from "react";
import * as API from '../../framework/API/api'
import BossDialog from "../../components/BossDialog";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { ENTITYNAME, TOAST_TYPES } from "../../framework/constant/constant";
import MyMultiSelect from "../../components/MyMultiSelect";
import ToastNotification from "../../components/ToastNotification";

const SegmentExtensionEditForm = (props) => {

    const { segmentId, onCancel } = props;
    const lang = useTranslation();

    const blankDataItem = {
        workingTitle: "",
        dealReference: "",
        videoFormat: {},
        platforms: []
    };
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [videoTypes, setVideoTypes] = useState([]);
    const [ottPlatforms, setOttPlatforms] = useState([]);

    useEffect(() => {
        loadCombo();
    }, []);

    useEffect(() => {
        loadData(segmentId);
    }, [segmentId]);

    const loadCombo = async () => {
        const videoTypeRes = await API.getDataLookup(ENTITYNAME.VideoType, { sort: { Description: 1 } });
        setVideoTypes(videoTypeRes.data);
        const ottPlatformRes = await API.getDataLookup(ENTITYNAME.Platform, { query: ["Archive", "!=", true] });
        setOttPlatforms(ottPlatformRes?.data ?? []);
    }

    const loadData = async (segmentId) => {
        const res = await API.getData(ENTITYNAME.MediaEpisodeSegment, { query: ["_id", "=", segmentId] });
        console.log(res);
        
        if (res.success) {
            const segmentData = res.data?.length > 0 ? res.data[0] : {};
            setDataItem(segmentData?.SegmentExtension ?? blankDataItem);
        } else {
            setDataItem(blankDataItem);
        }
    }

    const onChange = (e) => { setDataItem({ ...dataItem, [e.target.name]: e.target.value }) };

    const handleSubmit = async () => {
        const saveData = {
            workingTitle: dataItem?.workingTitle,
            dealReference: dataItem?.dealReference,
            videoFormat: dataItem?.videoFormat?._id ? { _id: dataItem?.videoFormat?._id, Description: dataItem?.videoFormat?.Description } : {},
            platforms: dataItem?.platforms?.length > 0 ? dataItem?.platforms?.map((x) => ({
                _id: x?._id,
                Description: x?.Description
            })) : []
        }
        let res = await API.saveData(ENTITYNAME.MediaEpisodeSegment, { SegmentExtension: saveData, _id: segmentId });
        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Segment Extension saved successfully" });
        }
        onCancel && onCancel();
    }

    return (
        <>
            <BossDialog title={lang.segment_extension_header} onClose={onCancel} width="700px">
                <EditPageHeader onSubmit={handleSubmit} onCancel={onCancel} showTitle={false} saveButtonTitle={lang.ok_label} />
                <div className="row mt-3">
                    <div className='col-6'>
                        <label className="app-form-label-compact">{lang.platform_label}</label>
                        <MyMultiSelect
                            style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
                            data={ottPlatforms}
                            name="platforms"
                            dataItemKey="_id"
                            textField="Description"
                            value={dataItem.platforms}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6">
                        <label className="app-form-label-compact">{lang.video_format_label}</label>
                        <DropDownList
                            style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
                            data={videoTypes}
                            name="videoFormat"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.videoFormat}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="row mt-3 mb-2">
                    <div className="col-6">
                        <label className="app-form-label-compact">{lang.working_title_label}</label>
                        <input
                            type="text"
                            name="workingTitle"
                            value={dataItem.workingTitle}
                            onChange={onChange}
                            className="form-control form-control-sm"
                        />
                    </div>
                    <div className="col-6">
                        <label className="app-form-label-compact">{lang.deal_reference_label}</label>
                        <input
                            type="text"
                            name="dealReference"
                            value={dataItem.dealReference}
                            onChange={onChange}
                            className="form-control form-control-sm"
                        />
                    </div>
                </div>
            </BossDialog>
        </>
    )
}

export default SegmentExtensionEditForm;